
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MenuComp from '../../src/components/Menu';

const RoutesConfig: React.FC = () => (
    <Routes>
        <Route path="/menu" element={<MenuComp />} />
    </Routes>
);

export default RoutesConfig;
